export const ASYNC_VALIDATOR_KEY = 'digitaix/forms/ASYNC_VALIDATOR';
export const CONTROL_METADATA_KEY = 'digitaix/forms/CONTROL';
export const FORM_ARRAY_METADATA_KEY = 'digitaix/forms/ARRAY';
export const FORM_EFFECT_METADATA_KEY = 'digitaix/forms/FORM_EFFECT';
export const FORM_GROUP_METADATA_KEY = 'digitaix/forms/GROUP';
export const ON_SET_VALUE_KEY = 'digitaix/forms/ON_SET_VALUE';
export const VALIDATOR_KEY = 'digitaix/forms/VALIDATOR_KEY';
export const FORM_DEFINITION_METADATA_KEY = 'digitaix/forms/FORM_DEFINITION';
export const FORM_INSTANCE_METADATA_KEY = 'digitaix/forms/FORM_INSTANCE';
export const ON_SUBMIT_VALID_METADATA_KEY = 'digitaix/forms/ON_SUBMIT_VALID';
export const ON_SUBMIT_INVALID_METADATA_KEY = 'digitaix/forms/ON_SUBMIT_INVALID';
export const ON_SUBMIT_METADATA_KEY = 'digitaix/forms/ON_SUBMIT';
export const ON_FORM_ERROR_METADATA_KEY = 'digitaix/forms/ON_FORM_ERROR';
export const ON_VALIDATION_ERROR_METADATA_KEY = 'digitaix/forms/ON_VALIDATION_ERROR';
export const ON_SUBMIT_SUCCESSFUL_METADATA_KEY = 'digitaix/forms/ON_SUBMIT_SUCCESSFUL';
export const ON_SUBMIT_FAILED_METADATA_KEY = 'digitaix/forms/ON_SUBMIT_FAILED';
export const STEP_METADATA_KEY = 'digitaix/forms/STEP_METADATA_KEY';
